// extracted by mini-css-extract-plugin
export default {"contentContainer":"SendReceiptContent_contentContainer__YpTIr","spinContainer":"SendReceiptContent_spinContainer__sdlVS"};